import React from "react";
import PaletteCouleursAffichageToutes from "../../../../boiteAOutils/PaletteCouleursAffichageToutes";

const SidebarImageSettings = ({setSidebarVisible, imageSettings, setImageSettings}) => {

    const {stroke, strokeWidth} = imageSettings;

    const handleStrokeWidthChange = (e) => {
        const newWidth = parseInt(e.target.value);
        setImageSettings(prev => ({...prev, strokeWidth: newWidth}));
    };

    return (
        <>
            <div className="sidebar-titre">
                Image
                <button onClick={() => setSidebarVisible(false)} className="toggle-button">
                    X
                </button>
            </div>

            <div className="sidebar-section">Bordure</div>
            <div className="sidebar-choix">
                <div className="libelle">Epaisseur</div>
                <select value={strokeWidth} onChange={handleStrokeWidthChange}>
                    <option value={null}>0pt</option>
                    <option value={1}>1pt</option>
                    <option value={2}>2pt</option>
                    <option value={3}>3pt</option>
                    <option value={4}>4pt</option>
                    <option value={10}>10pt</option>
                    <option value={20}>20pt</option>
                </select>
            </div>

            {/* Si tu veux aussi changer la couleur avec PaletteCouleursAffichageToutes */}
            <div className="sidebar-section">Couleur de la bordure</div>
            <PaletteCouleursAffichageToutes
                defaultColor={stroke}
                onColorChange={(color) => setImageSettings(prev => ({...prev, stroke: color}))}
            />

        </>
    );
};

export default SidebarImageSettings;
